export enum HttpStatusCodeEnum {
    NOT_FOUND = "404",
    UNPROCESSABLE_ENTITY = "422",
}

export enum HttpMethodEnum { DELETE = "delete" }
